// extracted by mini-css-extract-plugin
module.exports = {"children":"PointsGroup_children__1u7SD","formItem":"PointsGroup_formItem__2nuyf"};